import '@babel/polyfill';
import 'core-js/es/symbol';
import 'core-js/es/object/entries';
import 'core-js/es/object/from-entries';

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

require('abortcontroller-polyfill');
